<template>
  <span v-html="currencyFilter(value)" />
</template>

<script>
export default {
  name: 'BaseCurrencySpan',
  props: {
    value: {
      type: Number,
      required: true,
    },
  },
  methods: {
    currencyFilter(value) {
      return this.$options.filters.currency(value, { thousandsSeparator: '&nbsp;' });
    },
  },
};
</script>
